import React, { ComponentType, TextareaHTMLAttributes } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { TextArea } from '../TextArea/TextArea';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  Link: ComponentType<{ to: string; externalUS?: boolean }>;
}

const SpecificFeedback = ({ Link, onChange }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <h2 className='text-xl font-semibold mt-4'>{t('components.feedback.anythingElse')}</h2>
      <TextArea
        id='specific-feedback-text'
        label={t('components.feedback.specificFeedbackLabel')}
        onChange={onChange}
      />
      <div className='mb-4 text-sm'>
        <Trans
          i18nKey='components.feedback.disclaimer'
          components={{
            supportLink: <Link to='https://support.urbansitter.com/' externalUS />,
            supportEmail: <Link to='mailto:support@urbansitter.com' externalUS />,
          }}
        />
      </div>
    </>
  );
};

export { SpecificFeedback };
